/** `.dialog-noise` matches `.bento-noise`. Skip it on transparent shells, which paint their own backdrop. */
export function dialogNoiseClass(className?: string): string | undefined {
  if (typeof className === "string" && className.includes("bg-transparent")) return undefined
  return "dialog-noise"
}

export const dialogCloseClass =
  "absolute right-4 top-4 z-10 flex h-8 w-8 items-center justify-center rounded-md border-0 bg-transparent p-0 text-muted-foreground transition-colors hover:bg-accent hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none"

export const dialogContentClass =
  "fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 rounded-lg border bg-card p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%]"

/** Clears the close button. Callers that set px-* on the header must keep a pr-10 or the title slides under the icon. */
export const dialogHeaderClass =
  "flex flex-col space-y-1.5 text-center sm:text-left pr-8"

export const dialogFooterClass =
  "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2"

export const dialogTitleClass =
  "text-lg font-semibold leading-none tracking-tight text-foreground"

export const dialogDescriptionClass = "text-sm text-muted-foreground"
